'use strict';

const Rx = require('rx');
const splitBy = require('./splitBy');
const fromValuelessPromise = require('./fromValuelessPromise');

const {
  Observer,
  Notification,
  Scheduler,
  CompositeDisposable,
  Disposable,
  RefCountDisposable,
  SerialDisposable,
  SingleAssginmentDisposable,
} = Rx;

class AsyncSubject extends Rx.AsyncSubject {}
class BehaviorSubject extends Rx.BehaviorSubject {}
class ReplaySubject extends Rx.ReplaySubject {}
class Subject extends Rx.Subject {}
class Observable extends Rx.Observable {}

const OBSERVERABLES = [
  AsyncSubject,
  BehaviorSubject,
  ReplaySubject,
  Subject,
  Observable,
];

for (let observable of OBSERVERABLES) {
  observable.prototype.splitBy = splitBy;
}

module.exports = {
  Observer,
  Notification,
  Scheduler,
  CompositeDisposable,
  Disposable,
  RefCountDisposable,
  SerialDisposable,
  SingleAssginmentDisposable,
  AsyncSubject,
  BehaviorSubject,
  ReplaySubject,
  Subject,
  Observable,

  fromValuelessPromise,
};



// WEBPACK FOOTER //
// ./lib/rlink-rx/index.js